import {
    DIC
} from '@/const/dic'
import {
    validateChinese,
    anyPass,
    validateCapitalUnderline
} from '@/util/validate'
import {baseUrl} from '@/config/env';


const validateName = (rule, value, callback) => {
    if (!validateChinese(value) || value.length > 30 || value.length < 1) {
        callback(new Error('商品名称为1-30位中文'))
    } else {
        callback();
    }
}
const pass = (rule, value, callback) => {
    if (anyPass(value)) {
        console.log(value)
        callback()
    } else {
        callback();
    }
}

export const shopGoodsTableOption = {
    align: "center",
    menuAlign: "center",
    headerAlign: "center",
    border: true,
    expand: false,
    stripe: false,
    showHeader: true,
    // align: 'center',
    index: false,
    selection: true,
    menu: true,
    page: true,
    addBtn: false,
    editBtn: false,
    delBtn: false,
    viewBtn: false,
    menuWidth: '300',
    labelWidth: '200',
    defaultSort: {
        prop: 'createTime',
        order: 'descending'
    },
    column: [{
            label: "商品名称",
            prop: "name",
            placeholder: "请输入商品名称",
            search: true,
            type: 'input',
            rules: [{
                required: true,
                trigger: "blur",
                validator: validateName
            }]
        },
        {
            label: "商品型号",
            prop: "type",
            placeholder: "请输入商品型号",
            type: 'input',
            rules: [{
                required: true,
                trigger: "blur",
                min: 1,
                max: 16,
                message: "请输入商品型号"
            }]
        },
        {
            label: "商品单位",
            prop: "unit",
            placeholder: "请输入商品单位",
            type: 'input',
            rules: [{
                required: true,
                trigger: "blur",
                min: 1,
                max: 16,
                message: "请输入商品单位"
            }]
        },
        {
            label: "消费者价格",
            prop: "consumerPrice",
            placeholder: "请输入消费者价格",
            type: 'input',
            addVisdiplay: false,
            rules: [{
                required: true,
                trigger: "blur",
                message: "请输入消费者价格"
            }]
        },
        {
            label: "工程师价格",
            prop: "engineerPrice",
            placeholder: "请输入工程师价格",
            type: 'input',
            addVisdiplay: false,
            rules: [{
                required: true,
                trigger: "blur",
                message: "请输入工程师价格"
            }]
        },
        {
            label: "商户价格",
            prop: "merchantPrice",
            placeholder: "请输入商户价格",
            type: 'input',
            addVisdiplay: false,
            rules: [{
                required: true,
                trigger: "blur",
                message: "请输入商户价格"
            }]
        },
        {
            label: "品牌名称",
            prop: "brandId",
            solt: true,
            formsolt: true,
            rules: [{
                required: true,
                trigger: "change",
                validator: pass
            }]
        },
        {
            label: "一级分类",
            prop: "firstClassify",
            solt: true,
            formsolt: true
        },
        {
            label: "二级分类",
            prop: "secondClassify",
            solt: true,
            formsolt: true
        },
        {
            label: "商品状态",
            prop: "goodsStatus",
            type: "radio",
            dicData: DIC.GOODS_STATUS
        },
        {
            label: "描述图片",
            prop: "describeImgs",
            span: 24,
            hide: true,
            solt: true,
            formsolt: true
        },
        {
            label: "轮播图片",
            prop: "wheelsImgs",
            span: 24,
            solt: true,
            hide: true,
            formsolt: true
        },
        {
            label: "商品描述",
            prop: "goodsDescribe",
            type: "textarea",
            span: 24,
            hide: true,
            max: 255
        },
        {
            label: "创建时间",
            prop: "createTime",
            type: "datetime",
            sortable: true,
            format: "yyyy-MM-dd HH:mm:ss",
            addVisdiplay: false,
            editVisdiplay: false
        },
        {
            label: "创建人",
            prop: "createBy",
            type: "input",
            addVisdiplay: false,
            editVisdiplay: false
        },
        {
            label: "状态",
            prop: "status",
            type: "radio",
            addVisdiplay: false,
            editVisdiplay: false,
            dicData: DIC.STATUS_STATE_MODEL
        },
        {
            label: "更新时间",
            prop: "updateTime",
            type: "datetime",
            format: "yyyy-MM-dd HH:mm:ss",
            hide: true,
            addVisdiplay: false,
            editVisdiplay: false
        },
        {
            label: "更新人",
            prop: "updateBy",
            type: "input",
            hide: true,
            addVisdiplay: false,
            editVisdiplay: false
        },
        {
            label: "是否删除",
            prop: "deleteFlag",
            type: "radio",
            hide: true,
            addVisdiplay: false,
            editVisdiplay: false,
            dicData: DIC.DELETE_FLAG
        },
        {
            label: "备注",
            prop: "remarks",
            type: "textarea",
            span: 24,
            hide: true,
            max: 255
        }


    ]
};